export default __webpack_public_path__ + "static/media/4.061f5bf6.svg";